import cx from 'classnames';
import React from 'react';
import * as styles from '../UploadAssetWidget.scss';

const ImageControls = properties => (
  <div className={cx(styles.controls, { [styles.mobileControls]: properties.isTabletDevice })}>
    { !properties.isVideo && properties.mainImageTitle }
    <span
      title={properties.deleteFileTitle}
      onClick={properties.deleteImage}
      className={`${styles.delete} icon icon-close`}
    />
    {(!properties.isVideo && !properties.isRaw) && (
      <span
        title={properties.rotateImageTitle}
        onClick={properties.rotateImage}
        className={`${styles.rotate} icon icon-rotate`}
      />
    )}
  </div>
);

export default ImageControls;
